import { render, staticRenderFns } from "./FooterCardView.vue?vue&type=template&id=5ebfd5d1&scoped=true&"
import script from "./FooterCardView.vue?vue&type=script&lang=js&"
export * from "./FooterCardView.vue?vue&type=script&lang=js&"
import style0 from "./FooterCardView.vue?vue&type=style&index=0&id=5ebfd5d1&prod&lang=scss&scoped=true&"
import style1 from "./FooterCardView.vue?vue&type=style&index=1&id=5ebfd5d1&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebfd5d1",
  null
  
)

export default component.exports